import BaseDynamicPage from "%/dynamic-component-editor/classes/base-dynamic-page";
import ErrorId from "%/dynamic-component-editor/standard-pages/error-page/ErrorId.vue";

export default class ErrorPage extends BaseDynamicPage {

  static possibleElementVueComponents = [
    ErrorId,
  ];
}
